import React from 'react';
import _ from 'lodash';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import moment from 'moment';
import { getCurrencySymbol } from '../../../utils/getCurrencySymbol';

const BORDER_COLOR = '#8A9EAF';
const BORDER_STYLE = 'solid';

const styles = StyleSheet.create({
  details__header: {
    width: 50 + '%',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderBottomWidth: 1,
    borderRightWidth: 0,
    borderTopRightRadius: 0,
  },
  tableRow: {
    margin: 'auto',
    flexDirection: 'row',
    display: 'flex',
    width: 100 + '%',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderBottomWidth: 1,
  },
  tableRow__heading: {
    margin: 'auto',
    flexDirection: 'row',
    backgroundColor: 'rgba(231, 236, 244, .8)',
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderBottomWidth: 0,
    borderRadius: 0,
    overflow: 'hidden',
    marginTop: 10,
  },
  tableCellHeader: {
    margin: 5,
    fontSize: 8,
    fontFamily: 'Roboto',
    fontWeight: '600',
  },
  tableCellHeader__main: {
    margin: 5,
    fontSize: 8,
    fontFamily: 'Roboto',
    fontWeight: '600',
    paddingRight: 10,
  },
  tableCell: {
    margin: 5,
    fontSize: 7,
    fontFamily: 'Roboto',
    fontWeight: '400',
    textAlign: 'right',
  },
  main__heading: {
    fontSize: 10,
    fontFamily: 'Roboto',
    fontWeight: '600',
  },

  btn__styling: {
    borderRadius: 100,
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 15,
    paddingRight: 15,
    marginLeft: 15,
    marginBottom: 5,
    marginTop: 5,
    color: '#2CB46A',
    backgroundColor: 'rgba(49, 194, 116, .3)',
  },
  btn__styling__danger: {
    borderRadius: 100,
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 15,
    paddingRight: 15,
    marginLeft: 15,
    marginBottom: 5,
    marginTop: 5,
    color: '#FF3636',
    backgroundColor: '#FFD7D7',
  },
  btn__styling__no__action: {
    borderRadius: 100,
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 15,
    paddingRight: 15,
    marginLeft: 15,
    marginBottom: 5,
    marginTop: 5,
    color: '#263238',
    backgroundColor: '#E1E4E7',
  },
  main__status__btn: {
    fontSize: 8,
    fontFamily: 'Roboto',
    fontWeight: '500',
  },
  display__flex__row: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
  },
});

export default function AuthHistory({ authHistory, addCommasToNumber }) {
  authHistory =
    _.maxBy(authHistory, (o) => {
      return o.id;
    }) || '';

  if (authHistory?.jobsData?.length) {
    const totalCost = authHistory.jobsData?.reduce((prev, curr) => {
      if (curr?.authorizationStatus?.toLowerCase() === 'approved') {
        prev += +curr?.totalCost || 0;
      }

      return prev;
    }, 0);
    authHistory.totalCost = totalCost;
  }

  return (
    <>
      <View style={{ paddingTop: 10 }}>
        <Text style={styles.main__heading}>Authorization History:</Text>
      </View>
      {authHistory?.id ? (
        <View style={styles.table}>
          <View style={styles.tableRow__heading} wrap={false}>
            <View style={styles.details__header}>
              <Text style={styles.tableCellHeader}>
                {authHistory?.co_user
                  ? 'By ' +
                    (authHistory.co_user?.name || '') +
                    ' via ' +
                    authHistory?.authorizationMedium
                  : authHistory?.customer
                  ? 'By ' +
                    authHistory.customer?.name +
                    ' via Authorization Link'
                  : ''}
              </Text>
            </View>

            <View style={styles.details__header}>
              <Text style={styles.tableCell}>
                {moment(authHistory.createdAt).format('hh:mm A')} •{' '}
                {moment(authHistory.createdAt).format('MM/DD/YYYY')}{' '}
              </Text>
            </View>
          </View>
          {authHistory?.jobsData?.map((_item, index) => {
            return (
              <View style={styles.tableRow} key={index++} wrap={false}>
                <View style={styles.display__flex__row}>
                  <Text style={styles.tableCellHeader__main}>
                    {_item?.title}
                  </Text>
                  <View
                    style={
                      _item?.authorizationStatus?.toLowerCase() === 'approved'
                        ? styles.btn__styling
                        : _item?.authorizationStatus?.toLowerCase() ===
                          'declined'
                        ? styles.btn__styling__danger
                        : styles.btn__styling__no__action
                    }
                  >
                    <Text style={styles.main__status__btn}>
                      {_item?.authorizationStatus}
                    </Text>
                  </View>
                </View>

                <View>
                  <Text style={styles.tableCell}>
                    {getCurrencySymbol()}
                    {addCommasToNumber(
                      Math.round((+_item?.totalCost || 0) * 100) / 100,
                    )}
                  </Text>
                </View>
              </View>
            );
          })}
          <View style={styles.tableRow__heading} wrap={false}>
            <View style={styles.details__header}>
              <Text style={styles.tableCellHeader}>Total Amount:</Text>
            </View>
            <View style={styles.details__header}>
              <Text style={styles.tableCell}>
                {getCurrencySymbol()}
                {addCommasToNumber(
                  Math.round((+authHistory?.totalCost || 0) * 100) / 100,
                )}
              </Text>
            </View>
          </View>
        </View>
      ) : (
        <Text />
      )}
    </>
  );
}
